// extracted by mini-css-extract-plugin
export default {"fullScreenButton":"AnalyticsPage_fullScreenButton__DfJ07","fullScreenButtonOffset":"AnalyticsPage_fullScreenButtonOffset__su5Jb"};